export enum WidgetPopupType {
  INIT = 'INIT',
  INIT_WITH_CLOSE_BTN = 'INIT_WITH_CLOSE_BTN',
  STUCK_ON_PAGE = 'STUCK_ON_PAGE',
  RETURN_VISITOR = 'RETURN_VISITOR',
  VIEWED_PRODUCTS = 'VIEWED_PRODUCTS',
  CROSS_SALE = 'CROSS_SALE',
  HOVER = 'HOVER',
}
